import { mainSiteUrl } from "@/mocks/categories";

export default function CtaSection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Shopping%20bags%20and%20fashion%20items%20artistically%20arranged%20on%20warm%20cream%20surface%20with%20soft%20golden%20evening%20light%2C%20lifestyle%20product%20photography%2C%20warm%20amber%20and%20ivory%20tones%2C%20scandinavian%20minimalist%20aesthetic%2C%20gentle%20shadows%2C%20aspirational%20shopping%20mood%2C%20elevated%20retail%20atmosphere%2C%20clean%20harmonious%20composition&width=1600&height=800&seq=cta-bg-v2&orientation=landscape"
        alt="Optimize your workflow with ACBuySpreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 md:px-6 text-center py-16">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight uppercase tracking-wide">
          Optimize Your Workflow Today
        </h2>
        <p className="text-base md:text-lg text-white/80 mt-4 md:mt-6 max-w-[550px] mx-auto leading-relaxed">
          Join thousands of users managing orders faster with ACBuySpreadsheet.
        </p>

        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 mt-8 md:mt-10 px-8 py-4 bg-foreground-900 hover:bg-foreground-800 text-white rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap group"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-white text-sm"></i>
            </span>
          </span>
          <span className="text-sm font-semibold uppercase tracking-wider">Shop Main Store</span>
          <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
            <i className="ri-arrow-right-up-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}